<template>
  <div class="land8">
    <div
      id="land8-html"
      class="ql-editor"
      v-html="drawMiniRelayBackgroupImgUrl || ''"
      v-if="activityType == 2 && drawMiniRelayBackgroupImgUrl"
    ></div>
    <div
      id="land8-html"
      class="ql-editor"
      v-html="inviteDetail.h5Register || ''"
      v-else
    ></div>
    <RegisterBtn pageType="land8" :canRegister="canRegister" :errMsg="errMsg" />
  </div>
</template>

<script>
import { mixinAddRegVisitLog } from '@/util/mixins'
import { mixinCheckResponseIsErr } from '@ost/static/lib/mixin'
import RegisterBtn from '@/components/RegisterBtn'
import { getCookie, getQuery, getTopDomain } from '@/util/util'
import { getInviteInfo, validDraw } from '@/api/land'
import { COMMON_YES_NO } from '@/util/constants'

export default {
  naem: 'land8',
  components: {
    RegisterBtn
  },
  mixins: [mixinCheckResponseIsErr, mixinAddRegVisitLog],
  data () {
    return {
      channelCode: null, // 渠道码
      canRegister: true,
      errMsg: '',
      // 老带新活动详细信息
      inviteDetail: {
        h5Register: null, // 小程序&H5注册页
        isAward: COMMON_YES_NO.NO // 是否可获得奖励 0-无 1-有
      },
      activityType: 1, // 1-老带新活动 2-幸运转盘活动 3-推荐官计划
      drawMiniRelayBackgroupImgUrl: ''
    }
  },
  computed: {},
  created () {
    const query = getQuery()
    this.channelCode =
      query.channelNo || query.channelCode || getCookie('channelCode') || ''
    this.activityType = this.$route.query.activityType
      ? Number(this.$route.query.activityType)
      : 1
    console.log(this.activityType)

    if (this.activityType === 3) {
      document.title = '麦德通-现金奖励'
    }

    if (this.activityType != 2) {
      this.getInviteInfo(this.channelCode)
    } else {
      this.validDrawApi()
    }
  },
  methods: {
    async getInviteInfo (channelNo) {
      if (!channelNo) {
        this.activityEnd()

        return
      }

      const deviceId = await this.getDeviceId()
      const param = { code: channelNo, deviceId }

      if (this.activityType === 3) {
        // 推荐官计划
        param.inviteActivityType = 1
      }
      const res = await getInviteInfo(param).catch(e => null)

      if (this.checkResponseIsErr(res)) {
        return
      }

      if (!res.data) {
        // 活动已结束
        this.activityEnd()

        return
      }

      this.inviteDetail = res.data
      if (this.inviteDetail.isAward === COMMON_YES_NO.NO) {
        this.canRegister = false
        this.errMsg = `您不符合本活动条件，请参与其他活动！`
        this.$toast({ message: this.errMsg })
      }
    },
    /**
     * 活动结束处理
     */
    activityEnd () {
      this.canRegister = false
      this.errMsg = '抱歉，活动已结束，将为您自动跳转至首页'
      this.$toast({ message: this.errMsg })
      window.location.href = process.env.VUE_APP_MDT_MOBILE_URL
    },
    // 获取转盘活动信息
    async validDrawApi () {
      const deviceId = await this.getDeviceId()
      validDraw({
        deviceId,
        code: this.channelCode,
        activityType: this.activityType
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.drawMiniRelayBackgroupImgUrl =
              res.data.drawMiniRelayBackgroupImgUrl
          }
        })
        .catch(err => {
          this.$toast({ message: err.msg })
        })
    }
  }
}
</script>

<style lang="less">
@import "../assets/css/quill.bubble.css";

#land8-html {
  text-align: left;

  img {
    width: 100%;
  }
}
</style>

<style lang="less" scoped>
.ql-editor {
  padding: 0;
}

.land8 {
  padding-bottom: 143px;
}
</style>



// WEBPACK FOOTER //
// src/views/land8.vue